<template>
<div class="track-overview-table">
  <el-col>
    <el-card class="data">
      <div class="flex-space-between w100" slot="header">
        <div class="flex-center">
          <img class="report-img" src="@/assets/images/channels.svg" alt="" />
          <span>OVERVIEW</span>
        </div>
        <div class="videos-buttons">
          <el-tooltip content="Report" placement="top">
            <el-button
                type="success"
                circle
                icon="el-icon-document"
                @click="generateReport()"
                class="ml10"
            ></el-button>
          </el-tooltip>
        </div>
      </div>
      <div class="d-grid">
        <el-table class="w100" :data="tracks.data" v-loading="loading">
          <el-table-column label="Title" sortable>
            <template slot-scope="props">
              <router-link :to="{ name: 'Track Dashboard', query: { track: props.row.track }}">
                {{ props.row.title }}
              </router-link>
            </template>
          </el-table-column>

          <el-table-column label="Previews" prop="previews" align="center" :formatter="commaNumTable" sortable>
          </el-table-column>

          <el-table-column label="Views" prop="views" align="center" :formatter="commaNumTable" sortable>
          </el-table-column>

          <el-table-column label="Videos" prop="video" align="center" :formatter="commaNumTable" sortable>
          </el-table-column>
          <el-table-column label="Subscribers" prop="subscribers" align="center" :formatter="commaNumTable" sortable>
          </el-table-column>

          <el-table-column label="Actual CPM" align="center" :formatter="commaNumTable" sortable>
            <template slot-scope="props">
              {{ props.row.isFree ? 'Free' : '$'+props.row.actualCPM }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="float-right" background
            @size-change="sizeChange" @current-change="currentChange"
            :current-page.sync="tracks.current_page" :page-sizes="[5, 10, 25, 50, 100, 500]"
            :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="tracks.total"
        ></el-pagination>
      </div>
    </el-card>
  </el-col>
</div>
</template>

<script>
import axios from '@/plugins/axios'

export default {
  data() {
    return {
      tracks: [],
      loading: false,
      pageSize: 10,
      page: 1,
      order: { order_column: 'views', order_type: 'desc' },
      csv: 0
    }
  },

  methods: {
    async getTracks() {
      this.loading = true

      await axios.artist.get('track', {
        params: { ...this.order,
          page_size: this.pageSize,
          page: this.page,
          csv: this.csv,
          artistId: this.$store.state.artistDashboard.artist_label !== null
                  ? this.$store.state.artistDashboard.artist_label.id
                  : null
        }
      })
          .then(res => {
            if(this.csv == 1){
              this.csv = 0
              const url = window.URL.createObjectURL(new Blob([res.data]))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', 'report_my_tracks.csv')
              document.body.appendChild(link)
              link.click()
            }
            else
              this.tracks = res.data.data
          })
          .finally(() => {
            this.loading = false
          })
    },

    sizeChange(pageSize) {
      this.pageSize = pageSize
      this.getTracks()
    },

    currentChange(page) {
      this.page = page
      this.getTracks()
    },

    generateReport(){
      this.csv = 1
      this.getTracks()
    }
  },
  async created() {
    await this.getTracks()
  }
}
</script>
<style scoped>
.videos-buttons{
  display: flex;
}
</style>
